import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { cn } from "../../lib/utils";

// Aceternity hero-section-with-noise-background — background only, adapted
// for BookingFlows: accordion gradient strips + noise grain on white.
const Noise = () => (
  <div
    className="absolute inset-0 h-full w-full scale-[1.2] transform opacity-[0.05] [mask-image:radial-gradient(#fff,transparent,75%)]"
    style={{ backgroundImage: "url(/noise.webp)", backgroundSize: "20%" }}
  />
);

const StripsBackground = () => {
  const ref = useRef(null);
  const [strips, setStrips] = useState([]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const calc = () => {
      const width = el.offsetWidth || window.innerWidth;
      setStrips(Array.from({ length: Math.ceil(width / 80) }, (_, i) => i));
    };
    calc();
    const ro = new ResizeObserver(calc);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="absolute inset-0 z-0 flex [mask-image:radial-gradient(circle_at_center,white_0%,white_30%,transparent_70%)]"
      aria-hidden="true"
    >
      <Noise />
      {strips.map((index) => (
        <div
          key={index}
          className="h-full w-20 shrink-0 bg-gradient-to-r from-gray-100 to-white shadow-[2px_0px_0px_0px_rgba(0,0,0,0.09)]"
        />
      ))}
      {/* soft brand-blue wash so the texture reads BookingFlows, not generic */}
      <div className="absolute inset-x-0 top-0 h-72 bg-[radial-gradient(ellipse_at_top,rgba(37,99,235,0.08),transparent_60%)]" />
    </motion.div>
  );
};

export const NoiseStripsHero = ({ className, children, ...props }) => (
  <div className={cn("relative overflow-hidden bg-white px-4 pt-14 pb-12 sm:pt-20 sm:pb-16", className)} {...props}>
    <StripsBackground />
    <div className="relative z-10 w-full">{children}</div>
  </div>
);
